// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__Sf93F","related":"styles_related__1Ji7I"};